import { availableLocales } from '../src/config';

const load = lang => (
  () => import(`../src/locales/translation-${lang}.json` /* webpackChunkName: "CrowdIn-[request]" */)
);

const getCrowdinLanguages = () => availableLocales.reduce(
  (acc, lang) => ({ ...acc, ...{[`crowdin_${lang}`]: load(lang)} }), {}
);

const localesMap = {
  cs: () => import('../src/locales/locale-cs.json' /* webpackChunkName: "Locale-CS" */),
  da: () => import('../src/locales/locale-da.json' /* webpackChunkName: "Locale-DA" */),
  de: () => import('../src/locales/locale-de.json' /* webpackChunkName: "Locale-DE" */),
  el: () => import('../src/locales/locale-el.json' /* webpackChunkName: "Locale-EL" */),
  en: () => import('../src/locales/locale-en.json' /* webpackChunkName: "Locale-EN" */),
  es: () => import('../src/locales/locale-es.json' /* webpackChunkName: "Locale-ES" */),
  fi: () => import('../src/locales/locale-fi.json' /* webpackChunkName: "Locale-FI" */),
  fr: () => import('../src/locales/locale-fr.json' /* webpackChunkName: "Locale-FR" */),
  hr: () => import('../src/locales/locale-hr.json' /* webpackChunkName: "Locale-HR" */),
  hu: () => import('../src/locales/locale-hu.json' /* webpackChunkName: "Locale-HU" */),
  id: () => import('../src/locales/locale-id.json' /* webpackChunkName: "Locale-ID" */),
  it: () => import('../src/locales/locale-it.json' /* webpackChunkName: "Locale-IT" */),
  ja: () => import('../src/locales/locale-ja.json' /* webpackChunkName: "Locale-JA" */),
  ko: () => import('../src/locales/locale-ko.json' /* webpackChunkName: "Locale-KO" */),
  nb: () => import('../src/locales/locale-nb.json' /* webpackChunkName: "Locale-NB" */),
  nl: () => import('../src/locales/locale-nl.json' /* webpackChunkName: "Locale-NL" */),
  pl: () => import('../src/locales/locale-pl.json' /* webpackChunkName: "Locale-PL" */),
  pt: () => import('../src/locales/locale-pt.json' /* webpackChunkName: "Locale-PT" */),
  ru: () => import('../src/locales/locale-ru.json' /* webpackChunkName: "Locale-RU" */),
  sv: () => import('../src/locales/locale-sv.json' /* webpackChunkName: "Locale-SV" */),
  th: () => import('../src/locales/locale-th.json' /* webpackChunkName: "Locale-TH" */),
  tr: () => import('../src/locales/locale-tr.json' /* webpackChunkName: "Locale-TR" */),
  zh_CN: () => import('../src/locales/locale-zh_CN.json' /* webpackChunkName: "Locale-ZH_CN" */),
  zh_TW: () => import('../src/locales/locale-zh_TW.json' /* webpackChunkName: "Locale-ZH_TW" */),
  ...getCrowdinLanguages(),
};


const getError = lang => new Error(`There is no "${lang}" in application`);

const localesLoader = lang => (
  typeof localesMap[lang] === 'function' ? localesMap[lang]() : Promise.reject(getError(lang))
);

module.exports = localesLoader;
global.snFrontLocales = localesLoader;
